import { Component, OnInit } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import {
  faBan,
  faClose,
  faEdit,
  faListAlt,
  faPlus,
  faSave,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { NotifierService } from "angular-notifier";
import { SalesTeamShuffleService } from "src/app/services/administration/sales-team-shuffle.service";
import { FormField } from "src/app/interfaces/form-field.model";
import { tick } from "@angular/core/testing";
import { TitleStrategy } from "@angular/router";

@Component({
  selector: "app-sales-team-shuffle",
  templateUrl: "./sales-team-shuffle.component.html",
  styleUrls: ["./sales-team-shuffle.component.css"],
})
export class SalesTeamShuffleComponent implements OnInit {
  faEdit = faEdit;
  faListAlt = faListAlt;
  faClose = faClose;
  faPlus = faPlus;
  faTrash = faTrash;
  faSave = faSave;
  faBan = faBan;
  showMenu = false;
  showTeam = false;
  showDeleteConfirmation = false;
  isSaveDisabled = true;
  filteredUsers: any[] = [];
  teams: any[] = [];
  originalUsersInfo: any[] = [];
  fullTeamData: any[] = [];

  // Paginator variables
  pageSize: number = 25;
  pageIndex: number = 0;
  pageTop!: number;
  pageEvent: PageEvent | any;
  pageSizeOptions = [5, 25, 50];
  tableHeaders = [
    {
      title: "SALESMAN CODE",
      type: "data",
      width: "w-1/4",
      classes: "text-center",
    },
    {
      title: "NAME",
      type: "data",
      width: "w-1/2",
      classes: "",
    },
    {
      title: "TEAM",
      type: "select",
      width: "w-1/4",
      classes: "",
    },
  ];
  users_info: any[] = [];
  selectOptions: any[] = [];
  teamHeaders = [
    {
      id: "marked",
      title: "",
      type: "checkbox",
    },
    {
      id: "name",
      title: "NAME",
      type: "link",
    },
    {
      id: "description",
      title: "DESCRIPTION",
      type: "data",
    },
    {
      id: "id",
      tittle: "",
      type: "hidden",
    },
  ];

  teamEntries: any[] = [];
  selectedTeams: any[] = [];

  /* teamData = {
    TeamName: "",
    Description: "",
    Id: "",
  }; */

  teamForm: FormField[] = [
    { type: "text", id: "name", label: "Name", required: true },
    { type: "text", id: "description", label: "Description" },
    { type: "text", id: "id", label: "", show: false, value: 0 },
  ];
  private readonly notifier: NotifierService;

  constructor(
    notifierService: NotifierService,
    private salesTeamShuffleService: SalesTeamShuffleService,
  ) {
    this.notifier = notifierService;
    this.filteredUsers = this.users_info;
  }

  // Paginator update function
  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    if (
      this.pageSize * (this.pageIndex + 1) >
      this.users_info.length
    ) {
      this.pageTop = this.users_info.length;
    } else {
      this.pageTop = this.pageSize * (this.pageIndex + 1);
    }
  }

  returnzero() {
    return 0;
  }

  onSearch(searchValue: string): void {
    this.filteredUsers = this.users_info.filter(
      (item) =>
        item.salesmanCode
          .toLowerCase()
          .includes(searchValue.toLowerCase()) ||
        item.name.toLowerCase().includes(searchValue.toLowerCase()),
    );
  }

  assignValue(content: any, index: number) {
    this.users_info[index].team = content;
  }

  updateFields(event: any): void {
    this.teamForm = event.fields;
    this.isSaveDisabled =
      this.teamForm[0].value == null ? true : false;
  }

  /* assignTeam(event: any) {
    this.teamData = { ...this.teamData, ...event };
    console.log(this.teamData);
  } */

  openList(): void {
    this.salesTeamShuffleService.getAllSalesTeam().subscribe(
      (response) => {
        this.fullTeamData = response?.body;
        if (!this.fullTeamData || !Array.isArray(this.fullTeamData)) {
          console.error(
            "No data found in sales teams response:",
            response,
          );
          return;
        }

        this.teamEntries = this.fullTeamData.map((team: any) => ({
          marked: false,
          name: team.TeamName,
          description: team.Description,
          id: team.Id,
        }));

        this.showTeam = false;
        this.showMenu = true;
      },
      (error) => {
        console.error("Error fetching sales team data:", error);
      },
    );
  }

  transformedEntries() {
    return this.fullTeamData.map((team: any) => ({
      marked: false,
      name: team.TeamName,
      description: team.Description,
    }));
  }

  openEntry(event: any) {
    this.teamForm[0].value = event.name;
    this.teamForm[1].value = event.description;
    this.teamForm[2].value = event.id;
    console.log(this.teamForm);
    this.showTeam = true;
  }

  addEntry() {
    this.teamForm[0].value = "";
    this.teamForm[1].value = "";
    this.teamForm[2].value = 0;
    this.showTeam = true;
  }

  ngOnInit() {
    this.pageTop = this.pageSize;

    this.salesTeamShuffleService.getAllSalesTeam().subscribe(
      (response) => {
        const salesTeams = response?.body;
        if (!salesTeams || !Array.isArray(salesTeams)) {
          console.error(
            "No data found in sales teams response:",
            response,
          );
          return;
        }

        this.fullTeamData = salesTeams.map((team: any) => ({
          Id: team.Id,
          TeamName: team.TeamName,
          Description: team.Description,
          IsDeleted: team.IsDeleted,
        }));

        this.selectOptions = salesTeams.map((team: any) => ({
          display: team.TeamName,
          value: team.TeamName,
        }));

        this.salesTeamShuffleService.getAllSalesman().subscribe(
          (response) => {
            const salesmen = response?.body;
            if (!salesmen || !Array.isArray(salesmen)) {
              console.error(
                "No data found in salesmen response:",
                response,
              );
              return;
            }

            this.users_info = salesmen.map((salesman: any) => ({
              salesmanCode: salesman.SalesmanCode,
              name: salesman.SalesmanDesc,
              team: salesman.Team,
            }));

            this.filteredUsers = [...this.users_info];
            this.originalUsersInfo = JSON.parse(
              JSON.stringify(this.users_info),
            );
          },
          (error) => {
            console.error("Error fetching salesman data:", error);
          },
        );
      },
      (error) => {
        console.error("Error fetching sales team data:", error);
      },
    );
  }

  updateChanges() {
    const changedUsers = this.users_info.filter((user, index) => {
      return user.team !== this.originalUsersInfo[index].team;
    });

    if (changedUsers.length > 0) {
      const updatedSalesmen = changedUsers.map((user) => {
        const fullData = this.users_info.find(
          (item) => item.salesmanCode === user.salesmanCode,
        );

        return {
          Salesman: fullData.name,
          SalesType: "SALESMAN",
          SalesmanCode: fullData.salesmanCode,
          SalesmanDesc: fullData.name,
          Team: user.team,
          UserId: fullData.UserId,
          isChanged: 1,
        };
      });

      const payload = { data: updatedSalesmen };

      this.salesTeamShuffleService
        .updateSalesmanTeam(payload)
        .subscribe(
          (response) => {
            this.notifier.notify(
              "success",
              "Changes saved successfully",
            );
            this.originalUsersInfo = JSON.parse(
              JSON.stringify(this.users_info),
            );
          },
          (error) => {
            console.error("Error updating salesman team:", error);
            this.notifier.notify("error", "Error saving changes");
          },
        );
    } else {
      this.notifier.notify("info", "No changes detected");
    }
  }

  saveTeam() {
    console.log(this.teamForm);
    if (this.teamForm[2].value == 0) {
      this.confirmSaveTeam();
    } else {
      this.salesTeamShuffleService
        .IsSalesTeamActive(this.teamForm[2].value)
        .subscribe({
          next: (response) => {
            if (response.body === false) {
              this.confirmSaveTeam();
            } else {
              const confirmed = confirm(
                "This team has been associated to salesman/s. Updating team information will update their respective team. Are you sure you want to continue?",
              );

              if (!confirmed) {
                return;
              }

              this.confirmSaveTeam();
            }
          },
          error: (error) => {
            console.log(error);
            this.notifier.notify("error", "Error");
            return;
          },
        });
    }
  }

  confirmSaveTeam() {
    const selectedTeam = {
      TeamName: this.teamForm[0].value,
      Description: this.teamForm[1].value,
      Id: this.teamForm[2].value,
    };

    this.salesTeamShuffleService
      .saveSalesTeam({ data: selectedTeam })
      .subscribe(
        (response) => {
          this.notifier.notify("success", "Team saved successfully");
          this.showTeam = false;
          this.loadTeams();
        },
        (error) => {
          console.error("Error saving team:", error);
          this.notifier.notify("error", "Error saving team");
        },
      );
  }

  loadTeams() {
    this.salesTeamShuffleService.getAllSalesTeam().subscribe(
      (response) => {
        const salesTeams = response?.body;
        if (!salesTeams || !Array.isArray(salesTeams)) {
          console.error(
            "No data found in sales teams response:",
            response,
          );
          return;
        }

        this.fullTeamData = salesTeams.map((team: any) => ({
          TeamName: team.TeamName,
          Description: team.Description,
          IsDeleted: team.IsDeleted,
          Id: team.Id,
        }));

        this.teamEntries = this.fullTeamData.map((team: any) => ({
          marked: false,
          name: team.TeamName,
          description: team.Description,
          id: team.Id,
        }));

        this.showMenu = true;
      },
      (error) => {
        console.error("Error fetching sales team data:", error);
      },
    );
  }

  deleteSelectedTeamsPartI() {
    this.selectedTeams = this.teamEntries
      .filter((team) => team.marked)
      .map((team) => {
        const fullData = this.fullTeamData.find(
          (item) => item.TeamName === team.name,
        );
        return {
          Id: fullData.Id,
          TeamName: team.name,
          Description: team.description,
          selected: true,
          IsDeleted: false,
        };
      });

    if (this.selectedTeams.length == 0) {
      this.notifier.notify("info", "No teams selected for deletion");
    } else {
      this.showDeleteConfirmation = true;
    }
  }

  deleteSelectedTeamsPartII() {
    this.salesTeamShuffleService
      .deleteSalesTeam(this.selectedTeams)
      .subscribe(
        (response) => {
          this.fullTeamData = response.body;
          this.teamEntries = this.fullTeamData.map((team: any) => ({
            marked: false,
            name: team.TeamName,
            description: team.Description,
            id: team.Id,
          }));
          this.showDeleteConfirmation = false;
          let message = response.code == 1 ? "error" : "success";
          this.notifier.notify(message, response.message);
        },
        (error) => {
          console.error(error);
          this.notifier.notify("error", "Error");
        },
      );
  }
}
